import React from 'react';
import '../../App.css';
import VehicleForm from '../VehicleForm'

function VehiclePage({ sessionObject, showToast}) {
  if(!sessionObject.sessionVariables["modules"].includes("vehicle")){
    return;}
  return (
    <div className="page-vehicle">
      <VehicleForm sessionObject={sessionObject} showToast={showToast}/>
    </div>
  );
}

export default VehiclePage;